import React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import analyticsContext from '../../components/analytics/Analytics';
import Question from './question';
import Qustions from './questionData';

class Questionar extends React.Component {
  state = {
    class: 'QuestionarFooter__Sticky',
    answeredQuestion: 0,
    answeredQuestionBar: 0,
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    scroll.scrollTo(100, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
    });
    let answeredQuestion1 = 0,
      answeredQuestionBar1 = 0;

    Qustions.items.map((item) => {
      if (item.answered == true) {
        (answeredQuestion1 = answeredQuestion1 + 1), (answeredQuestionBar1 = answeredQuestionBar1 + 20);
      }
    });
    this.setState({
      answeredQuestion: answeredQuestion1,
      answeredQuestionBar: answeredQuestionBar1,
    });

    analyticsContext
      .withAdvancedProps({
        section: 'onboarding',
      })
      .screenEvent();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (window.pageYOffset >= 2800) {
      this.setState({ class: 'QuestionarFooter__NonSticky' });
    } else {
      this.setState({ class: 'QuestionarFooter__Sticky' });
    }
  };

  handleClick = (id, asweredStatus, question) => {
    let num = id + 1;
    let num0;
    if (id == 3 || id == 4) {
      num0 = document.getElementById(num).offsetTop - 150;
    } else {
      num0 = document.getElementById(num).offsetTop - 120;
    }
    scroll.scrollTo(num0, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
    });
    if (asweredStatus) {
      if (this.state.answeredQuestion < 5) {
        this.setState({
          answeredQuestion: this.state.answeredQuestion + 1,
          answeredQuestionBar: this.state.answeredQuestionBar + 20,
        });
      }
    }

    analyticsContext
      .withAdvancedProps({ action: 'questionAnswer', type: 'button', questionID: id, questionText: question })
      .controlEvent();
  };

  render() {
    return (
      <div className="QuestionarContainer1">
        <div className="QuestionarContainer">
          {Qustions.items.map((item) => {
            return (
              <div id={item.key} className="QuestionarContainer__question" key={item.key}>
                <Question question={item} increaseBar={this.handleClick} />
              </div>
            );
          })}
        </div>
        <div className="underline" />
        <Link className="QuestionarContainer-link" to={this.props.location.pathname.slice(0, 27) + '/result'}>
          <button id={6} className="QuestionarContainer-button">
            Submit
          </button>
        </Link>
        <footer className={`QuestionarFooter ${this.state.class}`}>
          <div className="QuestionarFooter__status">{this.state.answeredQuestion} out of 5 answered</div>
          <div className="QuestionarProgressBar">
            <div style={{ width: `${this.state.answeredQuestionBar}%` }} className="QuestionarProgressBar__inner" />
          </div>
        </footer>
      </div>
    );
  }
}

export default withRouter(Questionar);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/pages/onboarding/questionar.js